import { GetListParams, GetOneParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import {
  listWithdrawalProviderConfigs,
  getWithdrawalProviderConfig,
  updateWithdrawalProviderConfig,
} from '../../../services/xbitRelayService';
import { CHAIN_IDS } from './constants';

const resourceName = 'xbit-relay/withdrawal-provider-configs';

export const xbitRelayWithdrawalProviderConfigsDataProvider: CustomDataProvider = {
  async getList(_resource: string, _params: GetListParams): Promise<any> {
    const response = await listWithdrawalProviderConfigs();
    const items = response.data?.items ?? [];
    return {
      data: items.map((item) => ({ ...item, id: item.provider })),
      total: items.length,
    };
  },

  async getOne(_resource: string, params: GetOneParams): Promise<any> {
    const response = await getWithdrawalProviderConfig(String(params.id));
    const item = response.data?.item;
    return {
      data: { ...item, id: item.provider },
    };
  },

  async update(_resource: string, params: any): Promise<any> {
    const { id, data } = params;
    await updateWithdrawalProviderConfig(String(id), {
      auto_approval_max_amount: String(data.autoApprovalMaxAmount),
      frequency_window_min: String(data.frequencyWindowMin),
      frequency_max_requests: String(data.frequencyMaxRequests),
      // The form stores each fee under a stable per-chain key (chainFees.id_<chainId>), so
      // chain_id always comes from the known chain list and only filled-in rows are submitted.
      chain_withdrawal_fees: CHAIN_IDS.map((chainId) => ({
        chain_id: chainId,
        flat_fee: data.chainFees?.[`id_${chainId}`],
      }))
        .filter((fee) => fee.flat_fee !== '' && fee.flat_fee != null)
        .map((fee) => ({ chain_id: fee.chain_id, flat_fee: String(fee.flat_fee) })),
    });
    return { data: { ...data, id } };
  },
};

registerModuleDataProvider(resourceName, xbitRelayWithdrawalProviderConfigsDataProvider);
